module.exports = __webpack_public_path__ + "img/media_4.b5aad569.jpg";